//TODO: MOVE THIS INTO A SECRET FOLDER -- CANNOT BE EXPOSED LIKE THIS!
const firebaseConfig = require('../../config/firebase')
//Will be moved to a seperate auth service
const APIKEY =  firebaseConfig.apiKey

const baseUrl =  'https://identitytoolkit.googleapis.com/v1'

async function createUser(userCredentials) {
    
      const cors = require('cors')({origin: true});
var axios = require('axios')
const email = userCredentials.email
const password = userCredentials.password
      console.log(userCredentials)
      return await(axios.post(baseUrl + '/accounts:signUp?key={}'.format(APIKEY), {
            email,
            password,
            returnSecureToken: true
          }))
          //.then(result=>{console.log(result); return result}).catch((error) => {console.error("fb error", error); return(error)})

}

async function deleteUser(userCredentials) {
      const UID = userCredentials.UID
      const cors = require('cors')({origin: true});
var axios = require('axios')

      console.log(userCredentials)
      return await(axios.post(baseUrl + '/accounts:delete?key='.format(APIKEY), {
           idToken: UID
          }))
          //.then(result=>{console.log(result); return result}).catch((error) => {console.error("fb error", error); return(error)})

}

async function sendVerificationEmail(userCredentials) {
var axios = require('axios')
const UID = userCredentials.UID
//const email = userCredentials.email
      console.log(userCredentials)
      return await(axios.post('https://www.googleapis.com/identitytoolkit/v3/relyingparty/getOobConfirmationCode?key={}'.format(APIKEY), {
            "kind": "identitytoolkit#relyingparty",
            "requestType": 'VERIFY_EMAIL',
            "email": '',
            "challenge": '',
            "captchaResp": '',
            "userIp": '',
            "newEmail": '',
            "idToken": UID
          }))
          //.then(result=>{console.log(result); return result}).catch((error) => {console.error("fb error", error); return(error)})

}

async function sendPasswordResetEmail(userCredentials) {
      var axios = require('axios')
      const email = userCredentials.email
      //const email = userCredentials.email
            console.log(userCredentials)
            return await(axios.post('https://www.googleapis.com/identitytoolkit/v3/relyingparty/getOobConfirmationCode?key={}'.format(APIKEY), {
                  "kind": "identitytoolkit#relyingparty",
                  "requestType": 'PASSWORD_RESET',
                  "email": email
                }))
                //.then(result=>{console.log(result); return result}).catch((error) => {console.error("fb error", error); return(error)})
      
      }

async function getUser(userCredentials) {
      var axios = require('axios')
      const UID = userCredentials.UID
      //const email = userCredentials.email
            console.log("creds", userCredentials)
            return await(axios.post(baseUrl + '/accounts:lookup?key={}'.format(APIKEY), {
                  idToken:UID
                }))
                //.then(result=>{console.log(result); return result}).catch((error) => {console.error("fb error", error); return(error)})
      
      }

async function updateUser(userCredentials) {
            var axios = require('axios')
            //const email = userCredentials.email
                  console.log("creds", userCredentials)
                  return await(axios.post(baseUrl + '/accounts:lookup?key={}'.format(APIKEY), {
                        idToken:UID
                      }))
                      //.then(result=>{console.log(result); return result}).catch((error) => {console.error("fb error", error); return(error)})
            
            }      
      


async function signIn(userCredentials) {
      const cors = require('cors')({origin: true});
      var axios = require('axios')
      console.log(userCredentials)
      const email = userCredentials.email
      const password = userCredentials.password
      //works for now, TODO: find out how to correctly propogate ERRORS!!!
     return await(axios.post(baseUrl + '/accounts:signInWithPassword?key={}'.format(APIKEY), {
            email,
            password,
      returnSecureToken: true}))
      
     

      
      //.then((result) => new Promise((resolve) => {
      //       console.log("result", result)
      //       // if (result.state == 'fulfilled'){
      //       //       return result
      //       // }
      //       resolve()
      // })).catch((error) => new Promise((reject) => {
      //       console.log("error", error)
      //       reject(error)
      // }))

}

async function signOut(userCredentials) {
      const cors = require('cors')({origin: true});
var axios = require('axios')
      console.log(userCredentials)
      const response = axios.post(baseUrl + '/accounts:signUp?key=', {
            email: 'keith@aol.com',
            password: 'vdfgseg',
            returnSecureToken: true
          })
      console.log("response", response)

}

async function deleteAccount(userCredentials) {
      var axios = require('axios')
      console.log(userCredentials)
      const UID = userCredentials.UID

      //works for now, TODO: find out how to correctly propogate ERRORS!!!
     return await(axios.post(baseUrl + '/accounts:delete?key={}'.format(APIKEY), {
            idToken:UID}))
}
//---------------------------------Utility Functions---------------------
String.prototype.format = function () {
      var i = 0, args = arguments;
      return this.replace(/{}/g, function () {
        return typeof args[i] != 'undefined' ? args[i++] : '';
      });
    };
module.exports = {createUser, signIn, sendVerificationEmail,sendPasswordResetEmail, getUser, deleteAccount}


// WEBPACK FOOTER //
// ./src/services/firebaseAuth.js